import 'react-lazy-load-image-component/src/effects/blur.css';
import { useState } from 'react';
import { Blurhash } from 'react-blurhash';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export const ImageLazy = ({
  width, 
  height,
  src,
  placeholderSrc, 
  alt='', 
  effect='blur', 
  hash='LWPZx}of-;RjM|a|ofRj~payIUxt',
}) => {
  const [isLoadStarted, setLoadStarted] = useState(false);

  const handleLoadStarted = () => {
    setLoadStarted(true);
  };

  const handleLoadEnded = () => {
    setLoadStarted(false);
  };

  return(
    <>
      {isLoadStarted  ? (
        <Blurhash
          hash={hash}
          width={width}
          height={height}
          resolutionX={32}
          resolutionY={32}
          punch={1}
        />
      ) : null
      }

      <LazyLoadImage
        effect={effect}
        width={width}
        height={height}
        placeholderSrc={placeholderSrc}
        src={src} 
        alt={alt}
        beforeLoad={handleLoadStarted}
        afterLoad={handleLoadEnded}
      />
    </>
  );
};
